export default __webpack_public_path__ + "static/image1-27a38204681f3add099d3984a37cc1d4.webp";